<template>
  <div class="home">
    <div class="main-page">

      <div class="main-page__left">
        <form @submit.prevent="getData" @input="changeForm" class="app-form">
          <div class="app-form__header">Фильтрация</div>
          <div class="app-form__content">
            <div class="app-form__content-fields">
              <div class="app-form__field-item">
                <div class="app-form__field-name">От</div>
                <app-input v-model="date.from" type="date" />
              </div>
              <div class="app-form__field-item">
                <div class="app-form__field-name">До</div>
                <app-input v-model="date.to" type="date" />
              </div>
              <div style="min-width: 420px" class="app-form__field-item">
                <div class="app-form__field-name">Товар</div>
                <get-product @input="changeProductField" @change="chooseProduct" />
              </div>
            </div>

            <app-button type="submit" value="Запросить"></app-button>
          </div>
          <div style="font-size: 12px" class="app-form__description">
            Если товар не указан, будет отображена статистика по всему магазину (сумма всех показателей среди разных товаров)
          </div>
        </form>
      </div>

      <div class="main-page__right">
        <conversion-product-period
            v-if="statistics.array"
            :product="product_id"
            :is-disabled="isDisabledView"
            :key="periodKey"
            :statistic="statistics"
            :from="date.from"
            :to="date.to"
            :insales-id="insalesId"
        />
      </div>

    </div>
  </div>
</template>

<script>
import { Server } from "../api";
import AppInput from "../components/base-ui/app-input";
import AppButton from "../components/base-ui/app-button";
import ConversionProductDay from "../components/stats/conversionProductDay";
import ConversionProductPeriod from "../components/stats/conversionProductPeriod";
import GetProduct from "../components/product/getProduct";

const DAY_A_SECONDS = 1000 * 60 * 60 * 24;
const toDay = String(new Date(Date.parse(String(new Date()))).toISOString().split('T')[0]);
const fromDay = String(new Date(Date.parse(toDay) - (DAY_A_SECONDS * 7)).toISOString().split('T')[0]);

export default {
  name: 'home',
  components: {
    GetProduct,
    ConversionProductPeriod,
    ConversionProductDay,
    AppButton,
    AppInput
  },
  data: () => {
    return {
      productSearchQ: '',
      productSearchResult: [],
      isDisabledView: false,
      periodKey: 1,
      product_id: '',
      date: {
        from: fromDay,
        to: toDay
      }
    }
  },
  computed: {
    insalesId: function () {
      return this.$store.state.account.accountData.insales_id;
    },
    shop_url: function () {
      return this.$store.state.account.accountData.shop_url;
    },


    daysInPeriod() {
      return (new Date(this.date.to).getTime() - new Date(this.date.from).getTime()) / DAY_A_SECONDS
    },

    statistics() {
      return this.$store.state.statistics.data[0];
    },
  },
  methods: {
    getStatisticsByPeriod() {
      return this.$store.dispatch('getStatisticsByPeriod', {
        insales_id: this.insalesId,
        start: this.date.from.split('-').reverse().join('.'),
        end: this.date.to.split('-').reverse().join('.')
      }).then(response => response);
    },
    getStatisticsProductByPeriod() {
      return this.$store.dispatch('getStatisticsProductByPeriod', {
        insales_id: this.insalesId,
        product_id: this.product_id,
        start: this.date.from.split('-').reverse().join('.'),
        end: this.date.to.split('-').reverse().join('.')
      }).then(response => response);
    },

    changeForm() {
      // Добавить флаг блокировки до нажатия на кнопку отправить
      this.isDisabledView = true
    },

    searchProduct() {
      return Server.searchProduct({
        value: this.productSearchQ,
        shopHostUrl: this.shop_url
      })
      .then(response => {
        if (Array.isArray(response)) {
          console.log(response)
          this.productSearchResult = response;
        }
      })
    },

    chooseProduct: function (data) {
      this.product_id = data.productId;
      console.log('productId', data.productId)
    },

    changeProductField(e) {
      this.product_id = ''
    },

    getData: function () {
      if (this.product_id) {
        this.getStatisticsProductByPeriod()
          .then(() => {
            this.periodKey = this.periodKey + 1;
            this.isDisabledView = false
          })
      } else {
        this.getStatisticsByPeriod()
          .then(() => {
            this.periodKey = this.periodKey + 1;
            this.isDisabledView = false
          })
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.getData()
    }, 500);
  }
}
</script>

<style lang="scss">
.home {
  //position: relative;

  padding: 30px;

  overflow: hidden;

  & .analytics {
    margin-bottom: 40px;
  }
}
.main-page {
  display: flex;

  &__left {
    padding-right: 15px;
  }
  &__right {
    padding-left: 15px;
  }
}

@media(max-width: 1780px) {
  .main-page {
    flex-direction: column;

    &__left {
      padding-right: 0;
    }
    &__right {
      padding-left: 0;
    }

    & .app-form {
      max-width: 100%;
      width: 100%;
      margin-bottom: 30px;
    }
    & .app-form__content-fields {
      display: flex;
      width: 100%;
    }
    & .app-form__field-item {
      width: 100%;

      &:not(:last-child) {
        margin-right: 20px;
      }
    }
  }
}
</style>
